import { pageItemApi } from 'container/pageItemApi';
import { PageItemRepository } from 'repository/PageItemRepository';

export const pageItemRepository: PageItemRepository = new PageItemRepository(pageItemApi);
